const skuToIgnoreCOD = ["43849929654372","44203158437988","43849929752676","44203158470756","44212266762340","44212266795108","44212267483236","44212267516004","44203128291428","44203128389732","44090008305764","44212321386596","44212315881572","44212321419364","44212725776484","44212725809252","44212725842020","44212725874788","44212725973092","44212726005860","44212351139940","44212351172708","44212351205476","44203257036900","44203257102436","44203257167972","44203257266276","44212758020196","44212758052964","44212758085732","44212758118500","44212758151268","44212758184036"] 
const skuToAppendCOD = [] 

window.checkCODAvailability = function (skuList) {
  console.error("Checking",skuList);
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }
  
  if (ignoreCOD) {
    console.error("COD Locked 123", ignoreCOD);
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};
